import { TextField } from "@mui/material";

export const FormTextArea = ({
  formik,
  name,
  label,
  placeholder,
  isDisabled,
  rows = 4,
}) => {
  const error = formik.touched[name] && Boolean(formik.errors[name]);

  return (
    <TextField
      fullWidth
      multiline
      rows={rows}
      size="small"
      name={name}
      label={label}
      placeholder={placeholder}
      value={formik.values[name] || ""}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      disabled={isDisabled}
      error={error}
      helperText={formik.touched[name] && formik.errors[name]}
      InputLabelProps={{ sx: { fontSize: "0.8rem" } }}
    />
  );
};
